module.exports = __webpack_public_path__ + "img/0658ce061d06788fd1eb0d11f89dfb51.png";